import React, { PureComponent } from 'react';
import { I18n } from 'aws-amplify';
import styled from 'styled-components';
import {
    Table,
    Icon
} from 'antd';

import ItemCourse from './ItemCourse'

const Btns = styled.p`
width: 50px;
displa: block;
    a {
        margin-left: 10px;
    }
`


class tableCourse extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getSector = (sectorId) => {
        const items = this.props.sectorsFlat && this.props.sectorsFlat.filter((item) => item.code == sectorId);


        if (items && items.length) {
            return items[0].label;
        }
        else {
            return {};
        }

    }

    render() {
        const columns = [
            {
                title: I18n.get("Nome"),
                dataIndex: 'name',
                key: 'name',
                // render: (expertise) => this.getSector(expertise),
            },
            {
                title: I18n.get("Duração"),
                dataIndex: 'duration',
                key: 'duration',
            },
            {
                title: I18n.get("Formato"),
                dataIndex: 'format',
                key: 'format',
            },
            {
                title: '',
                dataIndex: 'actions',
                key: 'item',
                render: (text, record) => {
                    let data = {
                        id: record.item.id,
                        partnerId: this.props.partnerId,
                    }


                    if(!this.props.isView){
                        return (
                            <Btns>
                            <a onClick={() => this.props.edit(record.item)}>
                                <Icon type="edit" theme="filled" />
                            </a>
                            <a onClick={() => this.props.delete(data)}>
                                <Icon type="delete" theme="filled" />
                            </a>
                        </Btns>
                        )
                    }

                }
                // render: (record) => this.props.delMarketExpertise(record.item.id),
            },
        ]

        let dataCases = this.props.data && this.props.data.map((item, index) => {
            return {
                key: index,
                name: item.name,
                duration: item.duration,
                format: item.format,
                item: item
            }
        });

        return (
            <Table
                pagination={this.props.pagination ? true : false}
                columns={columns}
                dataSource={dataCases}
                scroll={{ x: 640 }}
                locale={{ emptyText: I18n.get('Sem informação') }}
                expandedRowRender={(record) => <ItemCourse item={record.item}

                />

            }
            />
        );
    }
}

export default tableCourse;
